import { styled } from '@mui/material';

export const Content = styled('div')({
  maxHeight: '95vh',
  overflow: 'auto',
});
